/** Display only: offer qualification and amounts remain server controlled. */
export type FeaturedDeal = { offerId: number; title: string; type: string; value: number; minOrderPence: number; scoped?: boolean; image: string | null; storeId: number; storeName: string; storeSlug: string | null };
export function featuredDealCopy(d: FeaturedDeal) {
  const headline = d.scoped ? d.title : d.type === "percentage" ? `${d.value}% off` : d.type === "fixed" ? `£${(d.value / 100).toFixed(2)} off` : d.type === "free_delivery" ? "Free delivery" : d.title || "A little extra, on us";
  const amount = (d.minOrderPence / 100).toFixed(2).replace(/\.00$/, "");
  // Merchant titles can already contain the minimum spend. Show it once.
  const includesMinimum = new RegExp(`£${amount.replace(".", "\\.")}(?![\\d.])`).test(headline);
  const detail = d.minOrderPence > 0 && !includesMinimum ? `Minimum order £${amount}` : "";
  return { headline, detail };
}
